import { api } from './api-base';
import type { GlobalSearchResponse, SearchGroup } from '../types';

interface SearchRequestOptions {
  limit?: number;
  page?: number;
  lat?: number;
  lng?: number;
  radiusKm?: number;
}

export const searchApi = {
  searchAll: async (query: string, options?: SearchRequestOptions): Promise<GlobalSearchResponse> => {
    const params: Record<string, string | number> = { q: query };
    if (options?.limit) params.limit = options.limit;
    if (options?.page) params.page = options.page;
    if (typeof options?.lat === 'number') params.lat = options.lat;
    if (typeof options?.lng === 'number') params.lng = options.lng;
    if (typeof options?.radiusKm === 'number') params.radiusKm = options.radiusKm;
    const response = await api.get('/search', { params });
    return response.data as GlobalSearchResponse;
  },
  searchGroup: async (query: string, group: SearchGroup, options?: SearchRequestOptions): Promise<GlobalSearchResponse> => {
    const params: Record<string, string | number> = { q: query, group };
    if (options?.limit) params.limit = options.limit;
    if (options?.page) params.page = options.page;
    if (typeof options?.lat === 'number') params.lat = options.lat;
    if (typeof options?.lng === 'number') params.lng = options.lng;
    if (typeof options?.radiusKm === 'number') params.radiusKm = options.radiusKm;
    const response = await api.get('/search', { params });
    return response.data as GlobalSearchResponse;
  }
};

export type { SearchRequestOptions };
